import i18n from '@/i18n'

// Ключи иконок пунктов обновления — тот же список, что config('system_updates.icons')
// на бэке: другой ключ бэк отклонит с 422.
export const ICON_KEYS = [
	'document',
	'settings',
	'pdf',
	'history',
	'chart',
	'map',
	'search',
	'filter',
	'users',
	'tools',
	'bell',
	'shield',
]

export const DEFAULT_CATEGORY_COLOR = '#157FEE'

// Лимиты длины на фронте. Строже, чем на бэке (там 255/1000/100/150 и без лимита
// на описания): тексты должны помещаться в окно при входе, колокольчик и карточку.
// Для HTML-описаний считаем видимый текст, а не разметку.
export const LIMITS = {
	title: 150,
	summary: 300,
	description: 5000,
	highlightTitle: 80,
	highlightSubtitle: 120,
	highlightDescription: 2000,
	categoryName: 50,
}

export function htmlTextLength(html) {
	if (!html) return 0
	return String(html)
		.replace(/<[^>]*>/g, '')
		.replace(/&nbsp;/g, ' ')
		.replace(/&[a-z]+;|&#\d+;/gi, '_')
		.trim().length
}

const HEX_RE = /^#[0-9a-f]{6}$/i

export function categoryColor(category) {
	const color = category && category.color
	return color && HEX_RE.test(color) ? color : DEFAULT_CATEGORY_COLOR
}

function hexToRgb(hex) {
	const value = parseInt(hex.slice(1), 16)
	return [(value >> 16) & 255, (value >> 8) & 255, value & 255]
}

// Бейдж категории: текст цветом категории на его же бледной подложке
export function categoryBadgeStyle(category) {
	const color = categoryColor(category)
	const [r, g, b] = hexToRgb(color)
	return {
		color,
		backgroundColor: `rgba(${r}, ${g}, ${b}, 0.12)`,
	}
}

function toDate(value) {
	if (!value) return null
	const date = new Date(value)
	return Number.isNaN(date.getTime()) ? null : date
}

// Месяцы пишем сами: в браузерах нет казахских названий для kk-KZ,
// и Intl выводит «2026 M10 15»
const MONTHS = {
	ru: [
		'января',
		'февраля',
		'марта',
		'апреля',
		'мая',
		'июня',
		'июля',
		'августа',
		'сентября',
		'октября',
		'ноября',
		'декабря',
	],
	kz: [
		'қаңтар',
		'ақпан',
		'наурыз',
		'сәуір',
		'мамыр',
		'маусым',
		'шілде',
		'тамыз',
		'қыркүйек',
		'қазан',
		'қараша',
		'желтоқсан',
	],
}

// «12 октября 2026 г.» / «12 қазан 2026 ж.»
export function formatUpdateDate(value) {
	const date = toDate(value)
	if (!date) return ''
	const kz = i18n.locale === 'kz'
	const month = (kz ? MONTHS.kz : MONTHS.ru)[date.getMonth()]
	return date.getDate() + ' ' + month + ' ' + date.getFullYear() + (kz ? ' ж.' : ' г.')
}

// «12.10.2026, 09:00» — для таблиц админки
export function formatUpdateDateTime(value) {
	const date = toDate(value)
	if (!date) return ''
	const pad = (n) => String(n).padStart(2, '0')
	return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}, ${pad(
		date.getHours(),
	)}:${pad(date.getMinutes())}`
}

// Текст ошибки из ответа: новые контроллеры шлют message, старые — error_message
export function apiErrorMessage(error, fallback) {
	const data = error && error.response && error.response.data
	return (data && (data.message || data.error_message)) || fallback
}
